import React, { useState, useEffect } from 'react';
import { Button, Badge } from 'react-bootstrap';
import { HiCheck, HiShieldCheck } from './Icons';
import './CommunityVote.css';

interface CommunityVoteProps {
  companyId: string;
  companyName: string;
}

export const CommunityVote: React.FC<CommunityVoteProps> = ({ companyId, companyName }) => {
  const storageKey = `coupon_vote_${companyId}`;
  const [hasVoted, setHasVoted] = useState<boolean>(false);
  const [voteCount, setVoteCount] = useState<number>(0);

  useEffect(() => {
    // Generate deterministic baseline vote count based on companyId characters
    const charCodeSum = companyId.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
    const baseVotes = 35 + (charCodeSum % 60);

    const savedVote = localStorage.getItem(storageKey);
    if (savedVote === 'yes') {
      setHasVoted(true);
      setVoteCount(baseVotes + 1);
    } else {
      setHasVoted(false);
      setVoteCount(baseVotes);
    }
  }, [companyId, storageKey]);

  const handleVote = (voteType: 'yes' | 'no') => {
    if (voteType === 'yes') {
      if (!hasVoted) {
        localStorage.setItem(storageKey, 'yes');
        setHasVoted(true);
        setVoteCount(prev => prev + 1);
      }
    } else {
      // Discard or report
      localStorage.setItem(storageKey, 'no');
      setHasVoted(false);
    }
  };

  return (
    <div className="community-vote-card mb-4">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
        <div className="d-flex align-items-center gap-2">
          <HiShieldCheck className="text-success fs-5" />
          <span className="community-vote-title">Community-Geprüft</span>
        </div>
        <Badge bg="success" className="bg-opacity-25 text-success-emphasis border border-success-subtle">
          98% Erfolgsquote
        </Badge>
      </div>

      <p className="community-vote-status mb-3">
        Zuletzt vor wenigen Stunden erfolgreich von {voteCount} Nutzern für <strong>{companyName}</strong> bestätigt.
      </p>

      <div className="d-flex align-items-center gap-2 flex-wrap">
        <span className="vote-question me-1">Funktioniert bei dir?</span>
        <Button
          variant={hasVoted ? 'success' : 'outline-success'}
          size="sm"
          className="vote-action-btn"
          onClick={() => handleVote('yes')}
          disabled={hasVoted}
        >
          <HiCheck className="me-1" />
          {hasVoted ? 'Danke für dein Feedback! 👍' : `Ja, funktioniert (${voteCount})`}
        </Button>
      </div>
    </div>
  );
};

export default CommunityVote;
